<template>
    <app-layout :racingstars="$page.props.racingstars" :jetstream="$page.props.jetstream" :user="$page.props.user" title="Milestones">
        <template #header>
            Rewards
        </template>
        <div class="dark:bg-gray-800 lg:dark:bg-gray-900 text-white lg:py-5 lg:px-6 lg:shadow transition duration-500 ease-in-out bg-white rounded-lg lg:border-2 border-gray-600 p-1 lg:p-4 m-2">
            <p class="text-center text-2xl font-semibold transition duration-500 ease-in-out text-white sm:text-gray-600 sm:dark:text-white col-span-1 md:col-span-2 pb-0 sm:pb-4">Rewards</p>
            
            <p class="text-center">To redeem our prizes please locate your nearest Racing League collection point and show the store teller your QR code when prompted.</p>
            <p class="text-center text-xs opacity-60">Make sure not to share your QR code with anyone. Please note these prizes are only available to players at the meeting.</p>     
            
            <div class="flex flex-col md:flex-row w-full mt-4">
                <div class="flex flex-wrap justify-center my-auto w-full">
                    <prize v-for="prize in prizes" :prize=prize :qrcode="'https://' + siteDomain + '/rewards/qrclaim/' + prize.uuid" class="my-auto"/>

                    <h class="text-center text-md font-bold" v-if="!prizes.length">Looks like you havent won any prizes yet. <br> Keep playing and keep an eye on this page!</h>
                </div>
            </div>
        </div>
        <rewards/>
    </app-layout>
</template>

<script>

import { ref } from 'vue'; 
import AppLayout from '@/Layouts/Layout'
import VuePlayerVideo from 'vue3-player-video'
import LevelProgressBar from './Partials/LevelProgressBar.vue'
import SmallProgressCircle from './Partials/SmallProgressCircle.vue'
import Prize from './Partials/Prize.vue'
import { GiftIcon } from '@heroicons/vue/outline'
import Rewards from './Partials/Rewards.vue'
import { onMounted } from 'vue';

export default {
    props: {
        items: {
            type: Array,
            default: []
        }
    },

    setup(props) {
        const prizes = ref(0)
        const siteDomain = ref(window.location.hostname)

        onMounted(() => {
            axios.get(route('api.reward.getunclaimedprizes'))
                .then(response => {
                    prizes.value = response.data
                }
            )
        })

        return {
            prizes,
            siteDomain
        }
    },

    components: {
        AppLayout,
        VuePlayerVideo,
        LevelProgressBar,
        SmallProgressCircle,
        Prize,
        GiftIcon,
        Rewards,
    },

}

</script>
